var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.500002, 224.999985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 -23.59375 L 8.5 -37.40625 L 51.5 -60.40625 L 51.5 -46.59375 L 21.796875 -30.90625 L 21.796875 -30.09375 L 51.5 -14.40625 L 51.5 -0.59375 Z M 8.5 -23.59375 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.497687, 224.999985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 43.5 0 L 39.09375 -16.796875 L 20 -16.796875 L 15.703125 0 L 0.5 0 L 19.40625 -69.796875 L 40.59375 -69.796875 L 59.5 0 Z M 30 -55.296875 L 29.203125 -55.296875 L 22.40625 -28.90625 L 36.796875 -28.90625 Z M 30 -55.296875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.495371, 224.999985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 51.09375 -69.796875 L 51.09375 -19.5 C 51.09375 -16.363281 50.539062 -13.507812 49.4375 -10.9375 C 48.34375 -8.375 46.78125 -6.191406 44.75 -4.390625 C 42.71875 -2.597656 40.265625 -1.21875 37.390625 -0.25 C 34.523438 0.71875 31.328125 1.203125 27.796875 1.203125 C 20.660156 1.203125 15.144531 -0.578125 11.25 -4.140625 C 7.351562 -7.710938 4.867188 -12.398438 3.796875 -18.203125 L 18 -21.09375 C 18.53125 -18.09375 19.546875 -15.660156 21.046875 -13.796875 C 22.546875 -11.929688 24.796875 -11 27.796875 -11 C 30.328125 -11 32.3125 -11.816406 33.75 -13.453125 C 35.1875 -15.085938 35.90625 -17.601562 35.90625 -21 L 35.90625 -57.5 L 12.90625 -57.5 L 12.90625 -69.796875 Z M 51.09375 -69.796875 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.493056, 224.999985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.296875 13.796875 L 39.40625 -76 L 52.703125 -76 L 20.59375 13.796875 Z M 7.296875 13.796875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.49074, 224.999985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 -14.40625 L 38.203125 -30.09375 L 38.203125 -30.90625 L 8.5 -46.59375 L 8.5 -60.40625 L 51.5 -37.40625 L 51.5 -23.59375 L 8.5 -0.59375 Z M 8.5 -14.40625 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb9cd97027272b70d82277ec070f2276.svg";
export { ForwardRef as ReactComponent };